"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const lodash_1 = require("lodash");
const moment_1 = __importDefault(require("moment"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const companyQuery_1 = require("../../../../queries/companyQuery");
const paymentQuery_1 = require("../../../../queries/paymentQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const service_1 = require("../../../../react-services/service");
const zustandStore_1 = require("../../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const drawerAside_1 = __importDefault(require("../../../organisms/drawerAside"));
const lexico = new lexico_1.default();
const StyledFormLabel = (0, material_1.styled)(material_1.FormLabel)(() => ({
    lineHeight: '10px',
    fontWeight: '600',
    fontSize: '12px',
    marginBottom: '10px',
}));
const reportTypes = (isAmexCardProvider) => [
    { id: 'requests', label: 'Requests' },
    { id: 'settlements', label: isAmexCardProvider ? 'Settlements' : 'Transactions' },
];
const ALL_SOURCE_CARDS = {
    label: lexico.trc('Option select title', 'All'),
    id: 'all',
};
function isCompanyOrSupportAdmin(userRole) {
    return appConstants_1.defaultAllowedRoles.includes(userRole);
}
function fetchCardSourceOptions(cardSources) {
    return [
        ALL_SOURCE_CARDS,
        ...cardSources.map(cardSource => ({
            id: cardSource?.id,
            label: `${cardSource?.name} (${cardSource?.lastDigits})`,
        })),
    ];
}
const date = new Date();
const DownloadReportAside = () => {
    const currentYear = date.getFullYear();
    const initialData = (0, react_router_1.useLoaderData)();
    const { isOpen, setNotification, filters, setIsDownloadReportAsideOpen, setDownloadFilters } = (0, zustandStore_1.useZustand)(state => ({
        filters: state.aside.downloadReportAside.filters,
        isOpen: state.aside.downloadReportAside.isOpen,
        setNotification: state.setNotification,
        setIsDownloadReportAsideOpen: state.setIsDownloadReportAsideOpen,
        setDownloadFilters: state.setDownloadReportAsideFilters,
    }));
    const firstOfMonth = (0, moment_1.default)({ month: Number(filters?.month), year: filters?.year });
    const createdAfter = firstOfMonth.format('YYYY-MM-DD');
    const createdBefore = firstOfMonth.endOf('month').add(1, 'days').format('YYYY-MM-DD');
    const teamId = isCompanyOrSupportAdmin(initialData.userRole) ? null : initialData.teamId;
    const { data: cardSources } = (0, paymentQuery_1.useGetCardSourcesQuery)({ teamId });
    const { data: currentUser } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)((0, companyQuery_1.companyPropertiesQuery)(currentUser?.companyAccountId || '', { cardprovider: 'tsgo-cardprovider' }));
    const isAmexCardProvider = companyPropertiesData?.cardprovider === 'AMEX';
    const isCardSourcesCollectionNonEmpty = cardSources && Array.isArray(cardSources) && cardSources?.length > 0;
    const reportParams = {
        cardSourceId: filters?.cardSourceOption === 'all' ? '' : filters?.cardSourceOption,
        reportType: filters?.reportType,
        createdBefore,
        createdAfter,
    };
    const options = {
        parentCards: isCardSourcesCollectionNonEmpty ? fetchCardSourceOptions(cardSources) : [ALL_SOURCE_CARDS],
        months: appConstants_1.months,
        years: (0, lodash_1.range)(2015, currentYear + 1),
    };
    (0, react_1.useEffect)(() => {
        setDownloadFilters({
            ...filters,
            reportType: 'settlements',
            cardSourceOption: ALL_SOURCE_CARDS.id,
            month: appConstants_1.months?.[date.getMonth()]?.value,
            year: currentYear,
        });
    }, []);
    const resetDownloadFilters = () => {
        setIsDownloadReportAsideOpen(false);
        setDownloadFilters({
            ...filters,
            reportType: 'settlements',
            cardSourceOption: ALL_SOURCE_CARDS.id,
            month: appConstants_1.months?.[date.getMonth()]?.value,
            year: currentYear,
        });
    };
    const footerButtons = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "download-report-button", onClick: () => {
                    void (0, service_1.downloadReport)(reportParams).then(report => {
                        if (!report.data) {
                            setNotification([
                                {
                                    type: strings_1.notificationStrings.WARNING,
                                    message: lexico.tr('There are no entries in this time period'),
                                },
                            ]);
                        }
                    });
                    resetDownloadFilters();
                }, color: uiConstants_1.UI_BUTTON_PRIMARY, style: { width: '100%' }, label: 'Download' }), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "download-report-button", onClick: () => resetDownloadFilters(), color: uiConstants_1.UI_BUTTON_SECONDARY, style: { width: '100%' }, label: 'Cancel' })] }));
    return ((0, jsx_runtime_1.jsx)(drawerAside_1.default, { id: "downloadReportAside", title: lexico.trc('Menu title', 'Download Report CSV'), open: isOpen, onClose: resetDownloadFilters, footerButtons: footerButtons, children: (0, jsx_runtime_1.jsx)(material_1.FormGroup, { style: { margin: 1, justifyContent: 'space-between', flex: 1 }, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { "data-testid": "report-filter", sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            m: 1,
                        }, children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { children: "REPORT TYPE" }), (0, jsx_runtime_1.jsx)(material_1.RadioGroup, { "aria-labelledby": "demo-controlled-radio-buttons-group", name: "controlled-radio-buttons-group", value: filters?.reportType, onChange: event => {
                                    setDownloadFilters({
                                        ...filters,
                                        reportType: event.target.value,
                                    });
                                }, sx: { p: 0 }, children: reportTypes(isAmexCardProvider).map(report => ((0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { value: report.id, control: (0, jsx_runtime_1.jsx)(material_1.Radio, {}), label: report.label }, report.id))) })] }), filters?.reportType === 'settlements' || filters?.reportType === 'transactions' ? ((0, jsx_runtime_1.jsxs)(material_1.Box, { "data-testid": "month-filter", sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            m: 1,
                        }, children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'PHYSICAL' : 'PARENT' + ' CARD FOR REPORT' }), (0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "parent-card-report-filter", value: filters?.cardSourceOption, onChange: event => {
                                    setDownloadFilters({
                                        ...filters,
                                        cardSourceOption: event.target.value,
                                    });
                                }, sx: { minWidth: 150 }, required: true, children: options?.parentCards?.map(type => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: type.id, children: type.label }, type.id))) }, "parent-card-report")] })) : null, (0, jsx_runtime_1.jsxs)(material_1.Box, { "data-testid": "month-filter", sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            m: 1,
                        }, children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { children: "MONTH" }), (0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "month-filter", value: filters?.month, onChange: event => {
                                    setDownloadFilters({
                                        ...filters,
                                        month: event.target.value,
                                    });
                                }, sx: { minWidth: 150 }, required: true, children: options?.months?.map(type => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: type?.value, children: type?.name }, type?.name))) }, "month")] }), (0, jsx_runtime_1.jsxs)(material_1.Box, { "data-testid": "year-filter", sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            m: 1,
                        }, children: [(0, jsx_runtime_1.jsx)(StyledFormLabel, { children: "YEAR" }), (0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "year-filter", value: filters?.year, onChange: event => {
                                    setDownloadFilters({
                                        ...filters,
                                        year: event.target.value,
                                    });
                                }, sx: { minWidth: 150 }, required: true, children: options?.years?.map((type, index) => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: type, children: type }, index))) }, "year")] })] }) }) }));
};
exports.default = DownloadReportAside;
